import React, { useEffect, useState } from 'react';
import { Box, Flex, useBreakpointValue } from '@chakra-ui/react';
import { Link, useLocation } from 'react-router-dom';
import { ArawaksLogo } from 'components/utils/ArawaksLogo';
import { Button } from '../../components/ui/Button';

const SOLID_TOPBAR_PATHS = [
  "/",
  "/actividades",
  "/contacto",
  "/camp",
  "/registro",
  "/design-system",
];

const usesSolidTopbar = (pathname) =>
  SOLID_TOPBAR_PATHS.some((path) => path === "/" ? pathname === "/" : pathname === path || pathname.startsWith(`${path}/`));

const Item = ({ title, to, selected, setSelected }) => (
  <Link to={to}>
    <Flex px="4" py="2" onClick={() => setSelected(title)} rounded="lg">
      <Flex align="center" gap="1" fontWeight={selected === title ? 'semibold' : 'medium'}>
        {title}
      </Flex>
    </Flex>
  </Link>
);

const Topbar = () => {
  const { pathname } = useLocation();
  const [selected, setSelected] = useState('Inicio');
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const el = document.getElementById('scrollableBody');
    const scroller = (!isMobile && el) ? el : window;

    const onScroll = () => {
      if (isMobile) return;
      const offset = scroller === window ? window.scrollY : el.scrollTop;
      setScrolled(offset > 2);
    };

    onScroll();

    if (scroller === window) {
      window.addEventListener('scroll', onScroll, { passive: true });
      return () => window.removeEventListener('scroll', onScroll);
    }

    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [isMobile]);

  const menuItems = (
    <>
      <Item title="Inicio" to="/" selected={selected} setSelected={setSelected} />
      <Item title="Actividades" to="/actividades" selected={selected} setSelected={setSelected} />
      <Item title="Camp" to="/camp" selected={selected} setSelected={setSelected} />
      <Item title="Contacto" to="/contacto" selected={selected} setSelected={setSelected} />
      {/*

      <Item title="Dashboard" to="/dashboard" selected={selected} setSelected={setSelected} icon={isMobile && <MdDashboard />} />
      */}
      <Button as={Link} to="/registro" variant="solid" color="red" size="md" radius="xl" fontSize="lg">
        ¡Registrate!
      </Button>
    </>
  );

  const solidTopbar = usesSolidTopbar(pathname);
  const isTopDesktop = !isMobile && !scrolled && !solidTopbar;

  return (
    <Box
      as="header"
      position="fixed"
      top="0"
      w="100%"
      zIndex="1000"
      bg={isTopDesktop ? "transparent" : "public.bg.panel"}
      borderBottomWidth={solidTopbar || scrolled ? "1px" : "0"}
      borderColor="public.border.subtle"
      boxShadow={!isMobile && scrolled ? "0 8px 24px rgba(45,55,72,.08)" : "none"}
      style={{ backdropFilter: (!isMobile && scrolled) ? "saturate(180%) blur(8px)" : "none" }}
      transition="background-color 500ms ease, backdrop-filter 500ms ease, box-shadow 500ms ease"
    >
      <Flex justify="space-between" align="center" px={{ base: 4, md: 20 }} py={{ base: 2, md: 4 }} color={isTopDesktop ? "white" : "public.fg.default"}>
        <Box w={{ base: "150px", md: "270px" }} flexShrink="0">
          <Link to="/">
            <ArawaksLogo
              w={{ base: "138px", md: "auto" }}
              h={{ base: "40px", md: "auto" }}
              maxW={{ base: "none", md: "70%" }}
              modeVariant={{ dark: "white", light: (isMobile || scrolled || solidTopbar) ? "black" : "white" }}
            />
          </Link>
        </Box>

        {isMobile ? (
          <Button as={Link} to="/registro" variant="solid" color="red" size="sm" radius="xl" fontSize="sm">
            Regístrate
          </Button>
        ) : (
          <Flex align="center" gap="1" fontSize="lg">
            {menuItems}
          </Flex>
        )}
      </Flex>
    </Box>
  );
};

export default Topbar;
